import { weddingPaths } from 'routes/paths';

const LAST_ROLE_KEY = 'last_role';
const LAST_EVENT_ID_KEY = 'last_event_id';

export type LastRole = 'couple' | 'admin' | 'uploader';

export function rememberLastRole(role: string | undefined | null, eventId?: string | null): void {
  if (!role) return;
  try {
    localStorage.setItem(LAST_ROLE_KEY, role);
    if (eventId) {
      localStorage.setItem(LAST_EVENT_ID_KEY, eventId);
    } else {
      localStorage.removeItem(LAST_EVENT_ID_KEY);
    }
  } catch {
    // localStorage unavailable (private mode, quota) — silently no-op
  }
}

export function clearLastRole(): void {
  try {
    localStorage.removeItem(LAST_ROLE_KEY);
    localStorage.removeItem(LAST_EVENT_ID_KEY);
  } catch {
    // ignore
  }
}

/**
 * Single source of truth for "where does an unauthenticated user belong?"
 * Used by AuthGuard, the api-client refresh-rejection path, and ProfileMenu's logout.
 */
export function getPostLogoutPath(): string {
  let lastRole: string | null = null;
  let lastEventId: string | null = null;
  try {
    lastRole = localStorage.getItem(LAST_ROLE_KEY);
    lastEventId = localStorage.getItem(LAST_EVENT_ID_KEY);
  } catch {
    // ignore
  }

  if (lastRole === 'uploader') {
    return lastEventId ? weddingPaths.guestJoin(lastEventId) : weddingPaths.guestJoinGeneral;
  }
  return weddingPaths.coupleLogin;
}
